/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AdvertisingFormatOverviewData,
    AdvertisingFormatOverviewDataFromJSON,
    AdvertisingFormatOverviewDataToJSON,
} from '../models/AdvertisingFormatOverviewData';
import {
    type BasicShopStatistics,
    BasicShopStatisticsFromJSON,
    BasicShopStatisticsToJSON,
} from '../models/BasicShopStatistics';
import {
    type CampaignMoneyGraphData,
    CampaignMoneyGraphDataFromJSON,
    CampaignMoneyGraphDataToJSON,
} from '../models/CampaignMoneyGraphData';
import {
    type CampaignNumberGraphData,
    CampaignNumberGraphDataFromJSON,
    CampaignNumberGraphDataToJSON,
} from '../models/CampaignNumberGraphData';
import {
    type CountryPaymentAndShippingStatistics,
    CountryPaymentAndShippingStatisticsFromJSON,
    CountryPaymentAndShippingStatisticsToJSON,
} from '../models/CountryPaymentAndShippingStatistics';
import {
    type CouponPerformance,
    CouponPerformanceFromJSON,
    CouponPerformanceToJSON,
} from '../models/CouponPerformance';
import {
    type CouponStats,
    CouponStatsFromJSON,
    CouponStatsToJSON,
} from '../models/CouponStats';
import {
    type DailyCountryData,
    DailyCountryDataFromJSON,
    DailyCountryDataToJSON,
} from '../models/DailyCountryData';
import {
    type DailyOverviewData,
    DailyOverviewDataFromJSON,
    DailyOverviewDataToJSON,
} from '../models/DailyOverviewData';
import {
    type DailyPaymentData,
    DailyPaymentDataFromJSON,
    DailyPaymentDataToJSON,
} from '../models/DailyPaymentData';
import {
    type DailyReportingCompositionData,
    DailyReportingCompositionDataFromJSON,
    DailyReportingCompositionDataToJSON,
} from '../models/DailyReportingCompositionData';
import {
    type DailyShippingData,
    DailyShippingDataFromJSON,
    DailyShippingDataToJSON,
} from '../models/DailyShippingData';
import {
    type DateRangeInput,
    DateRangeInputFromJSON,
    DateRangeInputToJSON,
} from '../models/DateRangeInput';
import {
    type DateRangeOrdersGranular,
    DateRangeOrdersGranularFromJSON,
    DateRangeOrdersGranularToJSON,
} from '../models/DateRangeOrdersGranular';
import {
    type DayInput,
    DayInputFromJSON,
    DayInputToJSON,
} from '../models/DayInput';
import {
    type DeliveryPaymentsData,
    DeliveryPaymentsDataFromJSON,
    DeliveryPaymentsDataToJSON,
} from '../models/DeliveryPaymentsData';
import {
    type DeliveryPaymentsFilter,
    DeliveryPaymentsFilterFromJSON,
    DeliveryPaymentsFilterToJSON,
} from '../models/DeliveryPaymentsFilter';
import {
    type DiscountPerformance,
    DiscountPerformanceFromJSON,
    DiscountPerformanceToJSON,
} from '../models/DiscountPerformance';
import {
    type ErpFilter,
    ErpFilterFromJSON,
    ErpFilterToJSON,
} from '../models/ErpFilter';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type LegacyCampaignPerformanceCompositionData,
    LegacyCampaignPerformanceCompositionDataFromJSON,
    LegacyCampaignPerformanceCompositionDataToJSON,
} from '../models/LegacyCampaignPerformanceCompositionData';
import {
    type LegacyMarketingAndSalesCompositionData,
    LegacyMarketingAndSalesCompositionDataFromJSON,
    LegacyMarketingAndSalesCompositionDataToJSON,
} from '../models/LegacyMarketingAndSalesCompositionData';
import {
    type MarketingDomainAuditData,
    MarketingDomainAuditDataFromJSON,
    MarketingDomainAuditDataToJSON,
} from '../models/MarketingDomainAuditData';
import {
    type MarketingTrendsCompositionData,
    MarketingTrendsCompositionDataFromJSON,
    MarketingTrendsCompositionDataToJSON,
} from '../models/MarketingTrendsCompositionData';
import {
    type MarketingTrendsData,
    MarketingTrendsDataFromJSON,
    MarketingTrendsDataToJSON,
} from '../models/MarketingTrendsData';
import {
    type OrderDomainCentreAuditData,
    OrderDomainCentreAuditDataFromJSON,
    OrderDomainCentreAuditDataToJSON,
} from '../models/OrderDomainCentreAuditData';
import {
    type OtherCostsData,
    OtherCostsDataFromJSON,
    OtherCostsDataToJSON,
} from '../models/OtherCostsData';
import {
    type OverviewCompositionData,
    OverviewCompositionDataFromJSON,
    OverviewCompositionDataToJSON,
} from '../models/OverviewCompositionData';
import {
    type PeriodComparisonData,
    PeriodComparisonDataFromJSON,
    PeriodComparisonDataToJSON,
} from '../models/PeriodComparisonData';
import {
    type PeriodComparisonInput,
    PeriodComparisonInputFromJSON,
    PeriodComparisonInputToJSON,
} from '../models/PeriodComparisonInput';
import {
    type PnoCompositionData,
    PnoCompositionDataFromJSON,
    PnoCompositionDataToJSON,
} from '../models/PnoCompositionData';
import {
    type ProductAssortmentData,
    ProductAssortmentDataFromJSON,
    ProductAssortmentDataToJSON,
} from '../models/ProductAssortmentData';
import {
    type ProductAssortmentPerformanceFilter,
    ProductAssortmentPerformanceFilterFromJSON,
    ProductAssortmentPerformanceFilterToJSON,
} from '../models/ProductAssortmentPerformanceFilter';
import {
    type ProductPerformanceDayInput,
    ProductPerformanceDayInputFromJSON,
    ProductPerformanceDayInputToJSON,
} from '../models/ProductPerformanceDayInput';
import {
    type ProductPerformanceFilter,
    ProductPerformanceFilterFromJSON,
    ProductPerformanceFilterToJSON,
} from '../models/ProductPerformanceFilter';
import {
    type ProductProfitabilityData,
    ProductProfitabilityDataFromJSON,
    ProductProfitabilityDataToJSON,
} from '../models/ProductProfitabilityData';
import {
    type ProductProfitabilityFilter,
    ProductProfitabilityFilterFromJSON,
    ProductProfitabilityFilterToJSON,
} from '../models/ProductProfitabilityFilter';
import {
    type ProjectDomainAuditData,
    ProjectDomainAuditDataFromJSON,
    ProjectDomainAuditDataToJSON,
} from '../models/ProjectDomainAuditData';
import {
    type ProjectDomainAuditInput,
    ProjectDomainAuditInputFromJSON,
    ProjectDomainAuditInputToJSON,
} from '../models/ProjectDomainAuditInput';
import {
    type PromotionPerformanceData,
    PromotionPerformanceDataFromJSON,
    PromotionPerformanceDataToJSON,
} from '../models/PromotionPerformanceData';
import {
    type ShopPerformance,
    ShopPerformanceFromJSON,
    ShopPerformanceToJSON,
} from '../models/ShopPerformance';
import {
    type ShopPerformanceDimensionData,
    ShopPerformanceDimensionDataFromJSON,
    ShopPerformanceDimensionDataToJSON,
} from '../models/ShopPerformanceDimensionData';
import {
    type ShopPerformancePno,
    ShopPerformancePnoFromJSON,
    ShopPerformancePnoToJSON,
} from '../models/ShopPerformancePno';
import {
    type StatisticsBySource,
    StatisticsBySourceFromJSON,
    StatisticsBySourceToJSON,
} from '../models/StatisticsBySource';
import {
    type TopChannelsData,
    TopChannelsDataFromJSON,
    TopChannelsDataToJSON,
} from '../models/TopChannelsData';
import {
    type TopProductData,
    TopProductDataFromJSON,
    TopProductDataToJSON,
} from '../models/TopProductData';
import {
    type TrackingQualityData,
    TrackingQualityDataFromJSON,
    TrackingQualityDataToJSON,
} from '../models/TrackingQualityData';
import {
    type TurnoverByDomain,
    TurnoverByDomainFromJSON,
    TurnoverByDomainToJSON,
} from '../models/TurnoverByDomain';

export interface AdvertisingFormatsRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ChannelPerformanceRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ClicksInTimeRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface CouponPerformanceRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface CpcInTimeRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface DailyCountryPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DailyCouponPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DailyOrderPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DailyPaymentPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DailyProductPerformanceRequest {
    projectId: string;
    productPerformanceDayInput?: ProductPerformanceDayInput;
}

export interface DailyShippingPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DailyTopChannelPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DeliveryPaymentsPerformanceRequest {
    projectId: string;
    deliveryPaymentsFilter?: DeliveryPaymentsFilter;
}

export interface DiscountPerformanceRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface MarketingDomainAuditRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface MarketingTrendsRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface OrderDomainCentreAuditRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface OrderOverviewRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface OrdersInTimeRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface OtherCostsPerformanceRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface PnoInTimeRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ProductAssortmentPerformanceRequest {
    projectId: string;
    productAssortmentPerformanceFilter?: ProductAssortmentPerformanceFilter;
}

export interface ProductPerformanceRequest {
    projectId: string;
    productPerformanceFilter?: ProductPerformanceFilter;
}

export interface ProductProfitabilityRequest {
    projectId: string;
    productProfitabilityFilter?: ProductProfitabilityFilter;
}

export interface ProjectDomainAuditRequest {
    projectId: string;
    projectDomainAuditInput?: ProjectDomainAuditInput;
}

export interface PromotionPerformanceRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ReportingDailyRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface ReportingLegacyCampaignPerformanceRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ReportingLegacyMarketingAndSalesRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ReportingMarketingTrendsRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ReportingOverviewRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ReportingPNORequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ReportingPeriodComparisonRequest {
    projectId: string;
    periodComparisonInput?: PeriodComparisonInput;
}

export interface ShopBasicStatisticsRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopChannelsStatisticsBySourceRequest {
    projectId: string;
    dateRangeInput?: DateRangeInput;
}

export interface ShopCountryPaymentAndShippingStatisticsRequest {
    projectId: string;
    dateRangeInput?: DateRangeInput;
}

export interface ShopPerformanceRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopPerformanceByCentreRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopPerformanceByDomainRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopPerformancePNOChannelsOnlyRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopPerformancePNOTotalRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopPerformancePNOTotalWithoutOfflineRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopTurnoverByDomainStatisticsRequest {
    projectId: string;
    dateRangeInput?: DateRangeInput;
}

export interface TrackingQualityRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

/**
 * 
 */
export class ErpCalculationApi extends runtime.BaseAPI {

    /**
     * Creates request options for advertisingFormats without sending the request
     */
    async advertisingFormatsRequestOpts(requestParameters: AdvertisingFormatsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling advertisingFormats().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/reporting/advertising-formats`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns customer-facing advertising format and destination summaries.
     */
    async advertisingFormatsRaw(requestParameters: AdvertisingFormatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdvertisingFormatOverviewData>> {
        const requestOptions = await this.advertisingFormatsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdvertisingFormatOverviewDataFromJSON(jsonValue));
    }

    /**
     * Returns customer-facing advertising format and destination summaries.
     */
    async advertisingFormats(requestParameters: AdvertisingFormatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdvertisingFormatOverviewData> {
        const response = await this.advertisingFormatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for channelPerformance without sending the request
     */
    async channelPerformanceRequestOpts(requestParameters: ChannelPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling channelPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/channel-performance`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns top channels data.
     */
    async channelPerformanceRaw(requestParameters: ChannelPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopChannelsData>> {
        const requestOptions = await this.channelPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TopChannelsDataFromJSON(jsonValue));
    }

    /**
     * Returns top channels data.
     */
    async channelPerformance(requestParameters: ChannelPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopChannelsData> {
        const response = await this.channelPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for clicksInTime without sending the request
     */
    async clicksInTimeRequestOpts(requestParameters: ClicksInTimeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling clicksInTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/clicks-in-time`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns data file uri.
     */
    async clicksInTimeRaw(requestParameters: ClicksInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignNumberGraphData>> {
        const requestOptions = await this.clicksInTimeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignNumberGraphDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async clicksInTime(requestParameters: ClicksInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignNumberGraphData> {
        const response = await this.clicksInTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for couponPerformance without sending the request
     */
    async couponPerformanceRequestOpts(requestParameters: CouponPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling couponPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/coupon-performance`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns data.
     */
    async couponPerformanceRaw(requestParameters: CouponPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CouponPerformance>> {
        const requestOptions = await this.couponPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponPerformanceFromJSON(jsonValue));
    }

    /**
     * Returns data.
     */
    async couponPerformance(requestParameters: CouponPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CouponPerformance> {
        const response = await this.couponPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for cpcInTime without sending the request
     */
    async cpcInTimeRequestOpts(requestParameters: CpcInTimeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling cpcInTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/cpc-in-time`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns data file uri.
     */
    async cpcInTimeRaw(requestParameters: CpcInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignMoneyGraphData>> {
        const requestOptions = await this.cpcInTimeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignMoneyGraphDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async cpcInTime(requestParameters: CpcInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignMoneyGraphData> {
        const response = await this.cpcInTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dailyCountryPerformance without sending the request
     */
    async dailyCountryPerformanceRequestOpts(requestParameters: DailyCountryPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyCountryPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/daily-country-performance`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        };
    }

    /**
     * Returns data file uri.
     */
    async dailyCountryPerformanceRaw(requestParameters: DailyCountryPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyCountryData>> {
        const requestOptions = await this.dailyCountryPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DailyCountryDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async dailyCountryPerformance(requestParameters: DailyCountryPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyCountryData> {
        const response = await this.dailyCountryPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dailyCouponPerformance without sending the request
     */
    async dailyCouponPerformanceRequestOpts(requestParameters: DailyCouponPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyCouponPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/daily-coupons-performance`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        };
    }

    /**
     * Returns data file uri.
     */
    async dailyCouponPerformanceRaw(requestParameters: DailyCouponPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CouponStats>>> {
        const requestOptions = await this.dailyCouponPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CouponStatsFromJSON));
    }

    /**
     * Returns data file uri.
     */
    async dailyCouponPerformance(requestParameters: DailyCouponPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CouponStats>> {
        const response = await this.dailyCouponPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dailyOrderPerformance without sending the request
     */
    async dailyOrderPerformanceRequestOpts(requestParameters: DailyOrderPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyOrderPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/daily-order-performance`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        };
    }

    /**
     * Returns data file uri.
     */
    async dailyOrderPerformanceRaw(requestParameters: DailyOrderPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyOverviewData>> {
        const requestOptions = await this.dailyOrderPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DailyOverviewDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async dailyOrderPerformance(requestParameters: DailyOrderPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyOverviewData> {
        const response = await this.dailyOrderPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dailyPaymentPerformance without sending the request
     */
    async dailyPaymentPerformanceRequestOpts(requestParameters: DailyPaymentPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyPaymentPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/daily-payment-performance`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        };
    }

    /**
     * Returns payment data.
     */
    async dailyPaymentPerformanceRaw(requestParameters: DailyPaymentPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyPaymentData>> {
        const requestOptions = await this.dailyPaymentPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DailyPaymentDataFromJSON(jsonValue));
    }

    /**
     * Returns payment data.
     */
    async dailyPaymentPerformance(requestParameters: DailyPaymentPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyPaymentData> {
        const response = await this.dailyPaymentPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dailyProductPerformance without sending the request
     */
    async dailyProductPerformanceRequestOpts(requestParameters: DailyProductPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyProductPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/daily-product-performance`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductPerformanceDayInputToJSON(requestParameters['productPerformanceDayInput']),
        };
    }

    /**
     * Product performance data.
     */
    async dailyProductPerformanceRaw(requestParameters: DailyProductPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopProductData>> {
        const requestOptions = await this.dailyProductPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TopProductDataFromJSON(jsonValue));
    }

    /**
     * Product performance data.
     */
    async dailyProductPerformance(requestParameters: DailyProductPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopProductData> {
        const response = await this.dailyProductPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dailyShippingPerformance without sending the request
     */
    async dailyShippingPerformanceRequestOpts(requestParameters: DailyShippingPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyShippingPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/daily-shipping-performance`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        };
    }

    /**
     * Returns payment data.
     */
    async dailyShippingPerformanceRaw(requestParameters: DailyShippingPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyShippingData>> {
        const requestOptions = await this.dailyShippingPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DailyShippingDataFromJSON(jsonValue));
    }

    /**
     * Returns payment data.
     */
    async dailyShippingPerformance(requestParameters: DailyShippingPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyShippingData> {
        const response = await this.dailyShippingPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dailyTopChannelPerformance without sending the request
     */
    async dailyTopChannelPerformanceRequestOpts(requestParameters: DailyTopChannelPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyTopChannelPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/daily-top-channels-performance`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        };
    }

    /**
     * Returns top channel data.
     */
    async dailyTopChannelPerformanceRaw(requestParameters: DailyTopChannelPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopChannelsData>> {
        const requestOptions = await this.dailyTopChannelPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TopChannelsDataFromJSON(jsonValue));
    }

    /**
     * Returns top channel data.
     */
    async dailyTopChannelPerformance(requestParameters: DailyTopChannelPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopChannelsData> {
        const response = await this.dailyTopChannelPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deliveryPaymentsPerformance without sending the request
     */
    async deliveryPaymentsPerformanceRequestOpts(requestParameters: DeliveryPaymentsPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling deliveryPaymentsPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/delivery-payments-performance`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeliveryPaymentsFilterToJSON(requestParameters['deliveryPaymentsFilter']),
        };
    }

    /**
     * Returns payment, shipping and country aggregates for the filtered period.
     */
    async deliveryPaymentsPerformanceRaw(requestParameters: DeliveryPaymentsPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeliveryPaymentsData>> {
        const requestOptions = await this.deliveryPaymentsPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeliveryPaymentsDataFromJSON(jsonValue));
    }

    /**
     * Returns payment, shipping and country aggregates for the filtered period.
     */
    async deliveryPaymentsPerformance(requestParameters: DeliveryPaymentsPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeliveryPaymentsData> {
        const response = await this.deliveryPaymentsPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for discountPerformance without sending the request
     */
    async discountPerformanceRequestOpts(requestParameters: DiscountPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling discountPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/discount-performance`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns data.
     */
    async discountPerformanceRaw(requestParameters: DiscountPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DiscountPerformance>> {
        const requestOptions = await this.discountPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscountPerformanceFromJSON(jsonValue));
    }

    /**
     * Returns data.
     */
    async discountPerformance(requestParameters: DiscountPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DiscountPerformance> {
        const response = await this.discountPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for marketingDomainAudit without sending the request
     */
    async marketingDomainAuditRequestOpts(requestParameters: MarketingDomainAuditRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling marketingDomainAudit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/data-quality/marketing-domain-audit`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns marketing spend domain data quality audit.
     */
    async marketingDomainAuditRaw(requestParameters: MarketingDomainAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarketingDomainAuditData>> {
        const requestOptions = await this.marketingDomainAuditRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MarketingDomainAuditDataFromJSON(jsonValue));
    }

    /**
     * Returns marketing spend domain data quality audit.
     */
    async marketingDomainAudit(requestParameters: MarketingDomainAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarketingDomainAuditData> {
        const response = await this.marketingDomainAuditRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for marketingTrends without sending the request
     */
    async marketingTrendsRequestOpts(requestParameters: MarketingTrendsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling marketingTrends().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/marketing-trends`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns complete marketing trend totals for the selected filter.
     */
    async marketingTrendsRaw(requestParameters: MarketingTrendsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarketingTrendsData>> {
        const requestOptions = await this.marketingTrendsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MarketingTrendsDataFromJSON(jsonValue));
    }

    /**
     * Returns complete marketing trend totals for the selected filter.
     */
    async marketingTrends(requestParameters: MarketingTrendsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarketingTrendsData> {
        const response = await this.marketingTrendsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for orderDomainCentreAudit without sending the request
     */
    async orderDomainCentreAuditRequestOpts(requestParameters: OrderDomainCentreAuditRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling orderDomainCentreAudit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/data-quality/order-domain-centre-audit`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns order domain and centre data quality audit.
     */
    async orderDomainCentreAuditRaw(requestParameters: OrderDomainCentreAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrderDomainCentreAuditData>> {
        const requestOptions = await this.orderDomainCentreAuditRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrderDomainCentreAuditDataFromJSON(jsonValue));
    }

    /**
     * Returns order domain and centre data quality audit.
     */
    async orderDomainCentreAudit(requestParameters: OrderDomainCentreAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrderDomainCentreAuditData> {
        const response = await this.orderDomainCentreAuditRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for orderOverview without sending the request
     */
    async orderOverviewRequestOpts(requestParameters: OrderOverviewRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling orderOverview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/order-overview`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns data file uri.
     */
    async orderOverviewRaw(requestParameters: OrderOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DateRangeOrdersGranular>> {
        const requestOptions = await this.orderOverviewRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DateRangeOrdersGranularFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async orderOverview(requestParameters: OrderOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DateRangeOrdersGranular> {
        const response = await this.orderOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersInTime without sending the request
     */
    async ordersInTimeRequestOpts(requestParameters: OrdersInTimeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling ordersInTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/orders-in-time`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns data file uri.
     */
    async ordersInTimeRaw(requestParameters: OrdersInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignNumberGraphData>> {
        const requestOptions = await this.ordersInTimeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignNumberGraphDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async ordersInTime(requestParameters: OrdersInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignNumberGraphData> {
        const response = await this.ordersInTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for otherCostsPerformance without sending the request
     */
    async otherCostsPerformanceRequestOpts(requestParameters: OtherCostsPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling otherCostsPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/other-costs-performance`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns auditable, daily-prorated external costs in project currency.
     */
    async otherCostsPerformanceRaw(requestParameters: OtherCostsPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OtherCostsData>> {
        const requestOptions = await this.otherCostsPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OtherCostsDataFromJSON(jsonValue));
    }

    /**
     * Returns auditable, daily-prorated external costs in project currency.
     */
    async otherCostsPerformance(requestParameters: OtherCostsPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OtherCostsData> {
        const response = await this.otherCostsPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for pnoInTime without sending the request
     */
    async pnoInTimeRequestOpts(requestParameters: PnoInTimeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling pnoInTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/pno-in-time`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns data file uri.
     */
    async pnoInTimeRaw(requestParameters: PnoInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignNumberGraphData>> {
        const requestOptions = await this.pnoInTimeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignNumberGraphDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async pnoInTime(requestParameters: PnoInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignNumberGraphData> {
        const response = await this.pnoInTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for productAssortmentPerformance without sending the request
     */
    async productAssortmentPerformanceRequestOpts(requestParameters: ProductAssortmentPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling productAssortmentPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/product-assortment-performance`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductAssortmentPerformanceFilterToJSON(requestParameters['productAssortmentPerformanceFilter']),
        };
    }

    /**
     * Product assortment performance data for bounded full-assortment analyses.
     */
    async productAssortmentPerformanceRaw(requestParameters: ProductAssortmentPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductAssortmentData>> {
        const requestOptions = await this.productAssortmentPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductAssortmentDataFromJSON(jsonValue));
    }

    /**
     * Product assortment performance data for bounded full-assortment analyses.
     */
    async productAssortmentPerformance(requestParameters: ProductAssortmentPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductAssortmentData> {
        const response = await this.productAssortmentPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for productPerformance without sending the request
     */
    async productPerformanceRequestOpts(requestParameters: ProductPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling productPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/product-performance`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductPerformanceFilterToJSON(requestParameters['productPerformanceFilter']),
        };
    }

    /**
     * Product performance data.
     */
    async productPerformanceRaw(requestParameters: ProductPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopProductData>> {
        const requestOptions = await this.productPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TopProductDataFromJSON(jsonValue));
    }

    /**
     * Product performance data.
     */
    async productPerformance(requestParameters: ProductPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopProductData> {
        const response = await this.productPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for productProfitability without sending the request
     */
    async productProfitabilityRequestOpts(requestParameters: ProductProfitabilityRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling productProfitability().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/product-profitability`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductProfitabilityFilterToJSON(requestParameters['productProfitabilityFilter']),
        };
    }

    /**
     * Product profitability data with purchase price and allocated marketing spend.
     */
    async productProfitabilityRaw(requestParameters: ProductProfitabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProductProfitabilityData>> {
        const requestOptions = await this.productProfitabilityRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProductProfitabilityDataFromJSON(jsonValue));
    }

    /**
     * Product profitability data with purchase price and allocated marketing spend.
     */
    async productProfitability(requestParameters: ProductProfitabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProductProfitabilityData> {
        const response = await this.productProfitabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for projectDomainAudit without sending the request
     */
    async projectDomainAuditRequestOpts(requestParameters: ProjectDomainAuditRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling projectDomainAudit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/data-quality/project-domain-audit`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectDomainAuditInputToJSON(requestParameters['projectDomainAuditInput']),
        };
    }

    /**
     * Returns observed automatic project-domain resolution evidence.
     */
    async projectDomainAuditRaw(requestParameters: ProjectDomainAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProjectDomainAuditData>> {
        const requestOptions = await this.projectDomainAuditRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProjectDomainAuditDataFromJSON(jsonValue));
    }

    /**
     * Returns observed automatic project-domain resolution evidence.
     */
    async projectDomainAudit(requestParameters: ProjectDomainAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProjectDomainAuditData> {
        const response = await this.projectDomainAuditRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for promotionPerformance without sending the request
     */
    async promotionPerformanceRequestOpts(requestParameters: PromotionPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling promotionPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/promotion-performance`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns distinct-order promotion totals and coupon/discount detail.
     */
    async promotionPerformanceRaw(requestParameters: PromotionPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PromotionPerformanceData>> {
        const requestOptions = await this.promotionPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PromotionPerformanceDataFromJSON(jsonValue));
    }

    /**
     * Returns distinct-order promotion totals and coupon/discount detail.
     */
    async promotionPerformance(requestParameters: PromotionPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PromotionPerformanceData> {
        const response = await this.promotionPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for reportingDaily without sending the request
     */
    async reportingDailyRequestOpts(requestParameters: ReportingDailyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling reportingDaily().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/reporting/daily`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        };
    }

    /**
     * Returns current, previous-day and previous-week Redis-backed daily data from one shared snapshot query.
     */
    async reportingDailyRaw(requestParameters: ReportingDailyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyReportingCompositionData>> {
        const requestOptions = await this.reportingDailyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DailyReportingCompositionDataFromJSON(jsonValue));
    }

    /**
     * Returns current, previous-day and previous-week Redis-backed daily data from one shared snapshot query.
     */
    async reportingDaily(requestParameters: ReportingDailyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyReportingCompositionData> {
        const response = await this.reportingDailyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for reportingLegacyCampaignPerformance without sending the request
     */
    async reportingLegacyCampaignPerformanceRequestOpts(requestParameters: ReportingLegacyCampaignPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling reportingLegacyCampaignPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/reporting/legacy-campaign-performance`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns campaign trends, PNO summaries and channel rows from one shared snapshot request.
     */
    async reportingLegacyCampaignPerformanceRaw(requestParameters: ReportingLegacyCampaignPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LegacyCampaignPerformanceCompositionData>> {
        const requestOptions = await this.reportingLegacyCampaignPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LegacyCampaignPerformanceCompositionDataFromJSON(jsonValue));
    }

    /**
     * Returns campaign trends, PNO summaries and channel rows from one shared snapshot request.
     */
    async reportingLegacyCampaignPerformance(requestParameters: ReportingLegacyCampaignPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LegacyCampaignPerformanceCompositionData> {
        const response = await this.reportingLegacyCampaignPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for reportingLegacyMarketingAndSales without sending the request
     */
    async reportingLegacyMarketingAndSalesRequestOpts(requestParameters: ReportingLegacyMarketingAndSalesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling reportingLegacyMarketingAndSales().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/reporting/legacy-marketing-and-sales`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns the Redis-backed legacy marketing and sales panels from one shared snapshot request.
     */
    async reportingLegacyMarketingAndSalesRaw(requestParameters: ReportingLegacyMarketingAndSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LegacyMarketingAndSalesCompositionData>> {
        const requestOptions = await this.reportingLegacyMarketingAndSalesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LegacyMarketingAndSalesCompositionDataFromJSON(jsonValue));
    }

    /**
     * Returns the Redis-backed legacy marketing and sales panels from one shared snapshot request.
     */
    async reportingLegacyMarketingAndSales(requestParameters: ReportingLegacyMarketingAndSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LegacyMarketingAndSalesCompositionData> {
        const response = await this.reportingLegacyMarketingAndSalesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for reportingMarketingTrends without sending the request
     */
    async reportingMarketingTrendsRequestOpts(requestParameters: ReportingMarketingTrendsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling reportingMarketingTrends().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/reporting/marketing-trends`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns all Redis-backed marketing trends panels from one shared snapshot request.
     */
    async reportingMarketingTrendsRaw(requestParameters: ReportingMarketingTrendsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarketingTrendsCompositionData>> {
        const requestOptions = await this.reportingMarketingTrendsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MarketingTrendsCompositionDataFromJSON(jsonValue));
    }

    /**
     * Returns all Redis-backed marketing trends panels from one shared snapshot request.
     */
    async reportingMarketingTrends(requestParameters: ReportingMarketingTrendsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarketingTrendsCompositionData> {
        const response = await this.reportingMarketingTrendsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for reportingOverview without sending the request
     */
    async reportingOverviewRequestOpts(requestParameters: ReportingOverviewRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling reportingOverview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/reporting/overview`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns shop performance and permitted channel overviews from one shared snapshot request.
     */
    async reportingOverviewRaw(requestParameters: ReportingOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OverviewCompositionData>> {
        const requestOptions = await this.reportingOverviewRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OverviewCompositionDataFromJSON(jsonValue));
    }

    /**
     * Returns shop performance and permitted channel overviews from one shared snapshot request.
     */
    async reportingOverview(requestParameters: ReportingOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OverviewCompositionData> {
        const response = await this.reportingOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for reportingPNO without sending the request
     */
    async reportingPNORequestOpts(requestParameters: ReportingPNORequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling reportingPNO().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/reporting/pno`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns total, without-offline and channel-only PNO from one shared snapshot request.
     */
    async reportingPNORaw(requestParameters: ReportingPNORequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PnoCompositionData>> {
        const requestOptions = await this.reportingPNORequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PnoCompositionDataFromJSON(jsonValue));
    }

    /**
     * Returns total, without-offline and channel-only PNO from one shared snapshot request.
     */
    async reportingPNO(requestParameters: ReportingPNORequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PnoCompositionData> {
        const response = await this.reportingPNORaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for reportingPeriodComparison without sending the request
     */
    async reportingPeriodComparisonRequestOpts(requestParameters: ReportingPeriodComparisonRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling reportingPeriodComparison().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/reporting/period-comparison`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PeriodComparisonInputToJSON(requestParameters['periodComparisonInput']),
        };
    }

    /**
     * Returns current, previous and previous-year shop performance from one multi-range snapshot query.
     */
    async reportingPeriodComparisonRaw(requestParameters: ReportingPeriodComparisonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PeriodComparisonData>> {
        const requestOptions = await this.reportingPeriodComparisonRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PeriodComparisonDataFromJSON(jsonValue));
    }

    /**
     * Returns current, previous and previous-year shop performance from one multi-range snapshot query.
     */
    async reportingPeriodComparison(requestParameters: ReportingPeriodComparisonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PeriodComparisonData> {
        const response = await this.reportingPeriodComparisonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopBasicStatistics without sending the request
     */
    async shopBasicStatisticsRequestOpts(requestParameters: ShopBasicStatisticsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopBasicStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-statistics/basic`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns shop performance data.
     */
    async shopBasicStatisticsRaw(requestParameters: ShopBasicStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BasicShopStatistics>> {
        const requestOptions = await this.shopBasicStatisticsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BasicShopStatisticsFromJSON(jsonValue));
    }

    /**
     * Returns shop performance data.
     */
    async shopBasicStatistics(requestParameters: ShopBasicStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BasicShopStatistics> {
        const response = await this.shopBasicStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopChannelsStatisticsBySource without sending the request
     */
    async shopChannelsStatisticsBySourceRequestOpts(requestParameters: ShopChannelsStatisticsBySourceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopChannelsStatisticsBySource().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-statistics/statistics-by-source`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DateRangeInputToJSON(requestParameters['dateRangeInput']),
        };
    }

    /**
     * Returns shop performance data.
     */
    async shopChannelsStatisticsBySourceRaw(requestParameters: ShopChannelsStatisticsBySourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatisticsBySource>> {
        const requestOptions = await this.shopChannelsStatisticsBySourceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatisticsBySourceFromJSON(jsonValue));
    }

    /**
     * Returns shop performance data.
     */
    async shopChannelsStatisticsBySource(requestParameters: ShopChannelsStatisticsBySourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatisticsBySource> {
        const response = await this.shopChannelsStatisticsBySourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopCountryPaymentAndShippingStatistics without sending the request
     */
    async shopCountryPaymentAndShippingStatisticsRequestOpts(requestParameters: ShopCountryPaymentAndShippingStatisticsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopCountryPaymentAndShippingStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-statistics/country-payment-shipping`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DateRangeInputToJSON(requestParameters['dateRangeInput']),
        };
    }

    /**
     * Returns shop performance data.
     */
    async shopCountryPaymentAndShippingStatisticsRaw(requestParameters: ShopCountryPaymentAndShippingStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CountryPaymentAndShippingStatistics>> {
        const requestOptions = await this.shopCountryPaymentAndShippingStatisticsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CountryPaymentAndShippingStatisticsFromJSON(jsonValue));
    }

    /**
     * Returns shop performance data.
     */
    async shopCountryPaymentAndShippingStatistics(requestParameters: ShopCountryPaymentAndShippingStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CountryPaymentAndShippingStatistics> {
        const response = await this.shopCountryPaymentAndShippingStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopPerformance without sending the request
     */
    async shopPerformanceRequestOpts(requestParameters: ShopPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-performance`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns shop performance data.
     */
    async shopPerformanceRaw(requestParameters: ShopPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopPerformance>> {
        const requestOptions = await this.shopPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopPerformanceFromJSON(jsonValue));
    }

    /**
     * Returns shop performance data.
     */
    async shopPerformance(requestParameters: ShopPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopPerformance> {
        const response = await this.shopPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopPerformanceByCentre without sending the request
     */
    async shopPerformanceByCentreRequestOpts(requestParameters: ShopPerformanceByCentreRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopPerformanceByCentre().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-performance/by-centre`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns shop performance grouped by project centre.
     */
    async shopPerformanceByCentreRaw(requestParameters: ShopPerformanceByCentreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopPerformanceDimensionData>> {
        const requestOptions = await this.shopPerformanceByCentreRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopPerformanceDimensionDataFromJSON(jsonValue));
    }

    /**
     * Returns shop performance grouped by project centre.
     */
    async shopPerformanceByCentre(requestParameters: ShopPerformanceByCentreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopPerformanceDimensionData> {
        const response = await this.shopPerformanceByCentreRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopPerformanceByDomain without sending the request
     */
    async shopPerformanceByDomainRequestOpts(requestParameters: ShopPerformanceByDomainRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopPerformanceByDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-performance/by-domain`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns shop performance grouped by project domain.
     */
    async shopPerformanceByDomainRaw(requestParameters: ShopPerformanceByDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopPerformanceDimensionData>> {
        const requestOptions = await this.shopPerformanceByDomainRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopPerformanceDimensionDataFromJSON(jsonValue));
    }

    /**
     * Returns shop performance grouped by project domain.
     */
    async shopPerformanceByDomain(requestParameters: ShopPerformanceByDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopPerformanceDimensionData> {
        const response = await this.shopPerformanceByDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopPerformancePNOChannelsOnly without sending the request
     */
    async shopPerformancePNOChannelsOnlyRequestOpts(requestParameters: ShopPerformancePNOChannelsOnlyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopPerformancePNOChannelsOnly().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-performance-pno/channels-only`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOChannelsOnlyRaw(requestParameters: ShopPerformancePNOChannelsOnlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopPerformancePno>> {
        const requestOptions = await this.shopPerformancePNOChannelsOnlyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopPerformancePnoFromJSON(jsonValue));
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOChannelsOnly(requestParameters: ShopPerformancePNOChannelsOnlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopPerformancePno> {
        const response = await this.shopPerformancePNOChannelsOnlyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopPerformancePNOTotal without sending the request
     */
    async shopPerformancePNOTotalRequestOpts(requestParameters: ShopPerformancePNOTotalRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopPerformancePNOTotal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-performance-pno/total`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOTotalRaw(requestParameters: ShopPerformancePNOTotalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopPerformancePno>> {
        const requestOptions = await this.shopPerformancePNOTotalRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopPerformancePnoFromJSON(jsonValue));
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOTotal(requestParameters: ShopPerformancePNOTotalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopPerformancePno> {
        const response = await this.shopPerformancePNOTotalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopPerformancePNOTotalWithoutOffline without sending the request
     */
    async shopPerformancePNOTotalWithoutOfflineRequestOpts(requestParameters: ShopPerformancePNOTotalWithoutOfflineRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopPerformancePNOTotalWithoutOffline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-performance-pno/total-without-offline`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOTotalWithoutOfflineRaw(requestParameters: ShopPerformancePNOTotalWithoutOfflineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopPerformancePno>> {
        const requestOptions = await this.shopPerformancePNOTotalWithoutOfflineRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopPerformancePnoFromJSON(jsonValue));
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOTotalWithoutOffline(requestParameters: ShopPerformancePNOTotalWithoutOfflineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopPerformancePno> {
        const response = await this.shopPerformancePNOTotalWithoutOfflineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopTurnoverByDomainStatistics without sending the request
     */
    async shopTurnoverByDomainStatisticsRequestOpts(requestParameters: ShopTurnoverByDomainStatisticsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopTurnoverByDomainStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-statistics/turnover-by-domain`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DateRangeInputToJSON(requestParameters['dateRangeInput']),
        };
    }

    /**
     * Returns shop performance data.
     */
    async shopTurnoverByDomainStatisticsRaw(requestParameters: ShopTurnoverByDomainStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TurnoverByDomain>> {
        const requestOptions = await this.shopTurnoverByDomainStatisticsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TurnoverByDomainFromJSON(jsonValue));
    }

    /**
     * Returns shop performance data.
     */
    async shopTurnoverByDomainStatistics(requestParameters: ShopTurnoverByDomainStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TurnoverByDomain> {
        const response = await this.shopTurnoverByDomainStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for trackingQuality without sending the request
     */
    async trackingQualityRequestOpts(requestParameters: TrackingQualityRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling trackingQuality().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/data-quality/tracking-quality`;
        urlPath = urlPath.replace('{projectId}', encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns page event tracking and pairing quality metrics.
     */
    async trackingQualityRaw(requestParameters: TrackingQualityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrackingQualityData>> {
        const requestOptions = await this.trackingQualityRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrackingQualityDataFromJSON(jsonValue));
    }

    /**
     * Returns page event tracking and pairing quality metrics.
     */
    async trackingQuality(requestParameters: TrackingQualityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrackingQualityData> {
        const response = await this.trackingQualityRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
